import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  Inject,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DeleteModalComponent } from 'src/app/modals/delete-modal/delete-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as XLSX from 'xlsx';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import * as moment from 'moment';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';
//import { setFlagsFromString } from 'v8';

export interface Element {
  marketName: string;
  productTypeName: string;
  subproductType: string;
  expectedPrice: string;
  dateposted: string;
  unit: string;
  cropName: string;
  updatedBy: string;
  action: boolean;
}
export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: 'app-market-rate-historical-data',
  templateUrl: './market-rate-historical-data.component.html',
  styleUrls: ['./market-rate-historical-data.component.scss'],
  providers: [DatePipe],
})
export class MarketRateHistoricalDataComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });

  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selectable = true;
  removable = true;
  addOnBlur = true;

  displayedColumns = [
    'dateposted',
    'expectedPrice',
    'marketName',
    'cropName',
    'productTypeName',
    'subproductType',
    'unit',
    'updatedBy',
    'action',
  ];

  dataSource = new MatTableDataSource<Element>([]);

  avgCount: any = [];
  totalCount;

  totalMarket;
  totalMarketRate: any = [];
  userdata;
  HistoricalData = [];
  MarketPriceHistoricalData;

  selectedSorting: string;
  selectFilterData1;
  selectFilterData;
  searchData;
  filterbyText = '';

  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;

  public matChipArray = [];
  edit = false;
  prefillData: any = [];
  marketrateform: FormGroup;
  marketdata;
  marketdatalist;
  productdata;
  productdatalist = [];
  getProductList = [];
  cropData;
  cropDataList = [];
  subProductDataList = [];
  getSubProductList = [];
  unitDataList = [];
  subProductData;
  subproductdata;
  subproductdatalist = [];
  marketId;
  productId;
  cropId;
  unitID;
  subproductId;
  Remark;
  subProductTypeID;
  productTypeID;
  marketID;
  unitData;
  submitted = false;
  response;
  today = new Date();
  currentD = this.datePipe.transform(this.today, 'dd/MM/yyyy hh:mm:ss');
  marketRateID;
  id;

  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
    { value: '5', viewValue: 'Custom Date' },
  ];
  customDate = false;
  productList: [];
  // import
  importExcelBtn = false;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  isButtonVisible = false;
  lastFilePath: any;
  saveMarket = false;
  displayedColumns1 = [
    'Date',
    'Market',
    'Crop',
    'Product',
    'subProduct',
    'Rate',
    'Status',
  ];
  preview: boolean = false;
  productTypeList = ['Coconut', 'Copra', 'Tender Coconut'];
  varietyList = {
    Coconut: [
      'Big(>550 gms)',
      'Medium(400-550 gms)',
      'Small(<400 gms)',
      'Coconut With Husk',
      'Coconut without husk',
    ],
    Copra: [
      'Edible Copra',
      'Low Moisture Copra <5%',
      'Sada Copra',
      'Crude Copra',
      'Ball Copra',
    ],
    'Tender Coconut': ['Green', 'Orange'],
  };

  ranges: any = {
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };

  constructor(
    // public dialogRef: MatDialogRef<DeleteModalComponent>,
    // @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.formInIt();
    this.getMarketListData();
    this.getProductListData();
    this.getMarketPriceData();
    this.GetTotalCount();
    this.getHeader();
    this.getCropListData();
    this.getSubProductListData();
    this.getUnitDataList();
  }

  formInIt() {
    this.marketrateform = this.fb.group({
      id: ['', [Validators.required]],
      MarketId: ['', [Validators.required]],
      ProductId: ['', [Validators.required]],
      SubProductId: ['', [Validators.required]],
      cropId: ['', [Validators.required]],
      unitID: ['', [Validators.required]],
      Rate: [
        '',
        [Validators.required, Validators.min(1), Validators.max(100000000)],
      ],
      categoryID: [''],
    });
  }

  get f() {
    return this.marketrateform.controls;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getMarketListData() {
    this._userService.getMarketlist().subscribe((data) => {
      this.marketdata = data;
      this.marketdatalist = this.marketdata.result.data;
    });
  }

  getProductListData() {
    this._userService.getProductlistForHistorical().subscribe((data) => {
      this.productdata = data;
      this.productdatalist = this.productdata.result.data;
      this.productList = this.productdata.result.data[0]?.productType;
    });
  }

  getCropListData() {
    this._userService.getCropList().subscribe((data) => {
      this.cropData = data;
      this.cropDataList = this.cropData.result.data;
    });
  }
  getUnitDataList() {
    this._userService.getUnitList().subscribe((data) => {
      this.unitData = data;
      this.unitDataList = this.unitData.result.data;
    });
  }
  getSubProductListData() {
    this._userService.getSubProductTypeForHistorical().subscribe((data) => {
      this.subProductData = data;
      this.subProductDataList = this.subProductData.result.data;
    });
  }

  getMarketPriceData() {
    this.spinner.show();
    var postdata = {
      search: '',
      fromDate: '',
      todate: '',
      market: '',
      crop: '',
      product: '',
      subProduct: '',
      pageNumber: 0,
      pageSize: 10,
    };

    this._userService
      .getMarketPriceHistoricalData(postdata)
      .subscribe((data) => {
        this.MarketPriceHistoricalData = data;
        this.paginationProperty = this.MarketPriceHistoricalData.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.totalPages = this.paginationProperty.totalPages;
        this.dataSource = new MatTableDataSource<Element>(
          this.MarketPriceHistoricalData.result.data.list
        );

        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
  }

  GetTotalCount() {
    this._userService.getMarketCount().subscribe((data) => {
      this.totalCount = data;
      this.avgCount = this.totalCount.result.data;
    });
  }

  getHeader() {
    var postdata = {
      fromDate: '',
      toDate: '',
    };
    this._userService.getMarketHeader(postdata).subscribe((data) => {
      this.totalMarket = data;
      this.totalMarketRate = this.totalMarket.result.data;
    });
  }

  selectItem(item) {
    if (item.value == 'Custom Date') {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }

  // startdata; enddata;
  // getDate(dates) {
  //   this.formdate = dates.viewValue;
  //   this.enddata = dates.endDate ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss') : null;
  //   this.startdata = dates.startDate ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss') : null;
  // }

  startdata;
  enddata;
  sharedate;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd hh:mm:ss')
        : null;
    }
  }

  /*=========================================== apply filter ======================================================================== */
  filterbymarketName = '';
  marketName = '';
  filterbyformdate = '';
  formdate = '';
  filterbytodayte = '';
  todayte = '';
  filterbyProduct = '';
  productName: '';
  subProductName: '';
  filterbysubProductName: '';
  fromDate = '';
  filterbyfromDate = '';
  toDate = '';
  filterbytoDate = '';
  filterbysharedate;
  filterbycropId = '';
  cropName = '';
  applyfilter(checkEmpty) {
    if (
      checkEmpty &&
      !this.searchData &&
      !this.cropName &&
      !this.marketName &&
      !this.productName &&
      !this.subProductName &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.customDate == false;
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbymarketName = this.marketName;
      this.filterbyProduct = this.productName;
      this.filterbysubProductName = this.subProductName;
      this.filterbysharedate = this.sharedate;
      this.filterbyformdate = this.enddata;
      this.filterbytodayte = this.startdata;
      this.filterbycropId = this.cropName;

      let indexmarketName = this.matChipArray.findIndex(
        (x) => x.tag === 'marketName'
      );
      let indexproductName = this.matChipArray.findIndex(
        (x) => x.tag === 'productName'
      );
      let indexsubProductName = this.matChipArray.findIndex(
        (x) => x.tag === 'subProductName'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexcrop = this.matChipArray.findIndex((x) => x.tag === 'cropName');

      if (this.marketName != '') {
        if (indexmarketName > -1) {
          this.matChipArray[indexmarketName].name =
            'Market' + ':' + this.marketName;
        } else {
          if (this.marketName != '' && this.marketName != undefined) {
            this.matChipArray.push({
              name: 'Market' + ':' + this.marketName,
              tag: 'marketName',
              flag: true,
            });
          }
        }
      }
      if (this.cropName != '') {
        if (indexcrop > -1) {
          let cropid = this.cropDataList.filter(
            (x) => x.cropId === this.cropName
          )[0].cropName;
          this.matChipArray[indexcrop].name = 'Crop' + ':' + cropid;
        } else {
          if (this.cropName != '' && this.cropName != undefined) {
            let cropid = this.cropDataList.filter(
              (x) => x.cropId === this.cropName
            )[0].cropName;
            this.matChipArray.push({
              name: 'Crop' + ':' + cropid,
              tag: 'cropName',
              flag: true,
            });
          }
        }
      }

      if (this.productName != '') {
        if (indexproductName > -1) {
          this.matChipArray[indexproductName].name =
            'Product' + ':' + this.productName;
        } else {
          if (this.productName != '' && this.productName != undefined) {
            this.matChipArray.push({
              name: 'Product' + ':' + this.productName,
              tag: 'productName',
              flag: true,
            });
          }
        }
      }

      if (this.subProductName != '') {
        if (indexsubProductName > -1) {
          this.matChipArray[indexsubProductName].name =
            'Sub Product' + ':' + this.subProductName;
        } else {
          if (this.subProductName != '' && this.subProductName != undefined) {
            this.matChipArray.push({
              name: 'Sub Product' + ':' + this.subProductName,
              tag: 'subProductName',
              flag: true,
            });
          }
        }
      }
      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('MM/DD/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('MM/DD/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('MM/DD/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('MM/DD/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }
      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        market: this.filterbymarketName,
        product: this.filterbyProduct,
        subProduct: this.filterbysubProductName,
        crop: this.filterbycropId,
        pageNumber: 0,
        pageSize: 10,
      };
      this._userService
        .getMarketPriceHistoricalData(postdata)
        .subscribe((data) => {
          this.userdata = data;
          this.MarketPriceHistoricalData = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.dataSource = new MatTableDataSource(
            this.MarketPriceHistoricalData
          );
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    }
  }

  remove(index, tag): void {
    if (tag === 'marketName') {
      this.matChipArray.splice(index, 1);
      this.marketName = '';
    }
    if (tag === 'subProductName') {
      this.matChipArray.splice(index, 1);
      this.subProductName = '';
    }
    if (tag === 'productName') {
      this.matChipArray.splice(index, 1);
      this.productName = '';
    }
    if (tag === 'cropName') {
      this.matChipArray.splice(index, 1);
      this.cropName = '';
    }

    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
    }
    setTimeout(() => {
      this.applyfilter(false);
    }, 500);
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyfilter(false);
    }
  }

  formPage() {
    this.router.navigate(['/MarketPlace']);
  }

  dominantMarket() {
    this.router.navigate(['/dominant-market']);
  }

  /*Export csv file */
  apidata;
  maindata;
  filename;
  exportcsvdata = false;

  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {
      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        market: this.filterbymarketName,
        product: this.filterbyProduct,
        subProduct: this.filterbysubProductName,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        crop: this.filterbycropId,
      };

      this._userService
        .getMarketPriceHistoricalData(postdata)
        .subscribe((data) => {
          this.userdata = data;
          this.MarketPriceHistoricalData = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.dataSource = new MatTableDataSource(
            this.MarketPriceHistoricalData
          );
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    } else {
      postdata = {
        fromDate: '',
        todate: '',
        search: '',
        market: '',
        product: '',
        subProduct: '',
        crop: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService
        .getMarketPriceHistoricalData(postdata)
        .subscribe((data) => {
          this.userdata = data;
          this.MarketPriceHistoricalData = this.userdata.result.data.list;
          this.paginationProperty = this.userdata.result.data;
          this.length = this.paginationProperty.totalItems;
          this.previousPageIndex = this.paginationProperty.previousPageIndex;
          this.hasNextPage = this.paginationProperty.hasNextPage;
          this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
          this.pageIndex = this.paginationProperty.pageNumber;
          this.dataSource = new MatTableDataSource(
            this.MarketPriceHistoricalData
          );
          this.dataSource.sort = this.sort;
          this.spinner.hide();
        });
    }
  }

  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }
  //*******************************edit*********************************************** */
  listdata1;
  editPage(data1) {
    this.sharedate = '';
    this.edit = true;
    this.listdata1 = data1;
    this.marketrateform.get('id').setValue(data1.id);
    this.marketrateform.get('MarketId').setValue(data1.marketName);
    this.marketrateform.get('ProductId').setValue(data1.productTypeName);
    this.marketrateform.get('SubProductId').setValue(data1.subproductType);
    this.marketrateform.get('Rate').setValue(data1.expectedPrice);
    this.marketrateform.get('cropId').setValue(data1.cropName);
    this.marketrateform.get('unitID').setValue(data1.unitName);

    let a = this.productdatalist.find(
      (p) => p.productType == data1.productTypeName
    );
    // this.getproductId(a, data1.subproductType);
  }

  listPage() {
    this.edit = false;
    this.importExcelBtn = false;
  }

  quantity = 1;
  Rate;
  requirederror;

  // onSubmit() {
  //   this.submitted = true
  //   this.spinner.show()
  //   var quantityval: any = 1

  //   this.Rate = this.marketrateform.value.Rate;
  //   this.Remark = this.marketrateform.value.Remark;
  //   this.id = this.marketrateform.value.id;

  //   if (this.marketrateform.valid) {
  //     this.spinner.show()
  //     let text = confirm("Are you sure you want to publish this market rate?");
  //     if (text == true) {
  //       const data = [];
  //       if (this.marketId != undefined) {
  //         var marketId = {
  //           "operationType": 0,
  //           "path": "MarketID",
  //           "op": "replace",
  //           "value": this.marketId,
  //         }
  //         data.push(marketId);
  //       }

  //       if (this.productId != undefined) {
  //         var productId = {
  //           "operationType": 0,
  //           "path": "ProductTypeID",
  //           "op": "replace",
  //           "value": this.productId,
  //         }
  //         data.push(productId);
  //       }
  //       if (this.cropId != undefined) {
  //         var cropId = {
  //           "operationType": 0,
  //           "path": "cropId",
  //           "op": "replace",
  //           "value": this.cropId,
  //         }
  //         data.push(cropId);
  //       }
  //       if (this.unitID != undefined) {
  //         var unitId = {
  //           "operationType": 0,
  //           "path": "unitId",
  //           "op": "replace",
  //           "value": this.unitID,
  //         }
  //         data.push(unitId);
  //       }
  //       if (this.subproductId != undefined) {
  //         var subProductTypeID = {
  //           "operationType": 0,
  //           "path": "SubProductTypeID",
  //           "op": "replace",
  //           "value": this.subproductId,
  //         }
  //         data.push(subProductTypeID);
  //       }

  //       if (this.marketrateform.value.Rate != undefined) {
  //         var Rate = {
  //           "operationType": 0,
  //           "path": "ExpectedPrice",
  //           "op": "replace",
  //           "value": this.marketrateform.value.Rate,
  //         }
  //         data.push(Rate);
  //       }
  //       if (this.marketrateform.value.Remark != undefined) {
  //         var Remark = {
  //           "operationType": 0,
  //           "path": "Remark",
  //           "op": "replace",
  //           "value": this.marketrateform.value.Remark,
  //         }
  //         data.push(Remark);
  //       }
  //       this._userService.marketRateUpdate(this.id, data).subscribe(data => {
  //         this.response = data;
  //         this.spinner.hide()
  //         this.toastr.success(this.response.result.message, 'Success', {
  //           timeOut: 4000,
  //         });
  //       });
  //       this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
  //         this.router.navigate(['/market-rate-historical-data']);
  //         window.location.reload();
  //         this.spinner.hide();

  //       });
  //     } else {
  //       this.spinner.hide()
  //     }
  //   }
  //   else {
  //     this.spinner.hide()
  //     alert("Please enter valid and mandatory field peroperly")
  //   }
  //   this.quantity = this.marketrateform.value.Quantity
  //   this.Rate = this.marketrateform.value.Rate
  // }
  onSubmit() {
    this.submitted = true;
    // this.spinner.show();
    let remark;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe((data) => {
      this.spinner.show();
      remark = data;
      if (this.marketrateform.valid && remark) {
        const data: any = {
          marketRateID: this.marketrateform.value.id,
          marketID: this.marketdatalist?.filter(
            (x) => x.marketName === this.marketrateform.value.MarketId
          )[0].marketID,
          cropId: this.cropDataList?.filter(
            (x) => x.cropName === this.marketrateform.value.cropId
          )[0].cropId,
          unitId: this.unitDataList?.filter(
            (x) => x.unitName === this.marketrateform.value.unitID
          )[0].unitID,
          productTypeID: this.productdatalist?.filter(
            (x) => x.productType === this.marketrateform.value.ProductId
          )[0].productTypeCode,
          subProductTypeID: this.subProductDataList?.filter(
            (x) =>
              x.subProductTypeName === this.marketrateform.value.SubProductId
          )[0].subProductTypeCode,
          rate: this.marketrateform.value.Rate,
          remark: remark,
        };
        this._userService.marketRateUpdate(data).subscribe((data) => {
          this.sharedate = '';
          this.response = data;
          this.getMarketPriceData();
          this.spinner.hide();
          this.listPage();
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 4000,
          });
        });
      }
    });
  }

  subprodectfilterdata;
  productname;
  getproductId(data) {
    if(data.productTypeCode){
      this._userService
      .getSubProductType(data.productTypeCode)
      .subscribe((res: any) => {
        this.subProductDataList = res.result.data;
      });
    }
  }

  getsubproductId(subproductId) {
    this.subproductId = subproductId;
  }

  deleteInputStream(data) {
    return (data.target.value = data.target.value.replace(/[^0-9.]/g, ''));
  }

  getMarketId(marketId) {
    this.marketId = marketId;
  }

  getcropId(cropId) {
    this.cropId = cropId;
    this._userService.getProductlist(cropId).subscribe((res: any) => {
      this.productdatalist = res.result.data;
    });
  }

  getUnitId(unitID) {
    this.unitID = unitID;
  }

  marketId1;
  openDialog(data2): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
    this.marketId1 = data2.id;

    const dialogRef = this.dialog.open(DeleteModalComponent, {
      // width: '30%',
      // height: '27%',
      data: this.marketId1,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.applyfilter(false);
      this.getHeader();
    });
  }

  //marketId1;
  openRemarkDialog() {
    let remark = this.marketrateform;
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }

  importPage() {
    this.sharedate = '';
    this.importExcelBtn = true;
    this.edit = false;
  }

  removeFile() {
    this.preview = false;
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }

  cancelPage() {
    this.preview = false;
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }

  fileData;
  finaldata;
  file1: File;
  file: File;
  arrayBuffer: any;
  filelist: any;
  jsonData: any;
  dataSource1;
  length1;

  removeFirstAndLastSpace(inputString) {
    // Remove leading and trailing spaces
    let trimmedString = inputString.trim();

    // Check if the first character is a space and remove it
    if (trimmedString[0] === ' ') {
      trimmedString = trimmedString.slice(1);
    }

    // Check if the last character is a space and remove it
    if (trimmedString[trimmedString.length - 1] === ' ') {
      trimmedString = trimmedString.slice(0, -1);
    }

    return trimmedString;
  }

  selectFile(event) {
    this.preview = false;
    this.isButtonVisible = true;
    // let files: FileList = event.target.files;
    // this.file1  = files[0];

    let splitfile = event.target.files[0].type;
    let type = splitfile.split('/');

    if (type[1] == 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      // this.finaldata = this.file1
      this.saveMarket = true;
      this.preview = true;
    } else {
      this.finaldata = 0;
      this.myInputVariable.nativeElement.value = '';
      this.saveMarket = false;
      this.isButtonVisible = false;
      this.toastr.warning('Accepted Xlxs file only', 'Info', {
        timeOut: 3000,
      });
      return;
    }

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: FileList = event.target.files;
    this.file1 = files[0];

    if (this.file1.size >= 1572864) {
      this.myInputVariable.nativeElement.value = '';
      this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
        timeOut: 3000,
      });
    } else {
      this.finaldata = this.file1;
      this.saveMarket = true;
    }
    this.file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(this.file);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = event.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        initial[name].map((x) => {
          // let myDate = x.Date.replace(/(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3");
          let myDate = x.Date.replace(
            /(\d*)-(\d*)-(\d*)/,
            (_, d, m, y, h, min) => `${m}/${d}/${y}`
          );
          //let myDate = this.normalizeDate(x.Date);
          x['Date'] = myDate;
          // x['Date']=moment(Date.parse(myDate)).format('MM/DD/YYYY');
          return x;
        });
        return initial;
      }, {});
      jsonData.Sheet1.forEach((ele) => {
        ele.Market = this.titleCase(this.removeFirstAndLastSpace(ele.Market));
        ele.Crop = this.titleCase(this.removeFirstAndLastSpace(ele.Crop));
        ele.Product = this.titleCase(
          this.removeFirstAndLastSpace(ele['Product type'])
        );
        ele.subProduct = this.titleCase(
          this.removeFirstAndLastSpace(ele['Sub Product type'])
        );
      });
      this.length1 = jsonData.Sheet1.length;
      // const dataString = JSON.stringify(jsonData);
      // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
      //this.setDownload(dataString);
      this.dataSource1 = new MatTableDataSource<Element>(jsonData.Sheet1);
    };
    reader.readAsBinaryString(file);
  }

  // date;
  // myFunction(){
  //   this.date=new Date();
  //   let latest_date =this.datePipe.transform(this.date, 'dd/MM/YYYY');
  //  }
  normalizeDate(input) {
    var parts = input.split('/');
    return (
      (parts[0] < 10 ? '0' : '') +
      parseInt(parts[0]) +
      '/' +
      (parts[1] < 10 ? '0' : '') +
      parseInt(parts[1]) +
      '/' +
      parseInt(parts[2] < 100 ? '20' + parts[2] : parts[2])
    );
  }
  isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }
  object = {};
  isValid(row) {
    return (
      this.isEmptyOrSpaces(row['Product type']) &&
      this.isEmptyOrSpaces(row['Sub Product type']) &&
      this.isEmptyOrSpaces(row.Market) &&
      this.isEmptyOrSpaces(row.Crop) &&
      this.isCrop(row.Crop) === '' &&
      this.isValidRate(row.Rate) === '' &&
      this.isMarket(row.Market) === '' &&
      this.isEmptyOrSpaces(row.Rate) &&
      this.isDate(row.Date) === '' &&
      this.isNumber(row.Rate) &&
      !this.isNumber(row.Market) &&
      !this.isNumber(row.Crop) &&
      !this.isNumber(row['Product type']) &&
      !this.isNumber(row['Sub Product type']) &&
      this.isValidVariety(row) === ''
    );
  }

  isEmptyOrSpaces(str) {
    return !(
      str === null ||
      str === undefined ||
      str.toString().match(/^ *$/) !== null
    );
  }
  marketNamecheck = [];
  isMarket(row) {
    this.marketNamecheck = [];
    this.marketdatalist.forEach((item) => {
      this.marketNamecheck.push(item.marketName);
    });
    if (this.isNumber(row) == true || !this.marketNamecheck.includes(row)) {
      return 'textRed';
    } else {
      return '';
    }
  }
  //********************************************** */
  cropNamecheck = [];
  isCrop(row) {
    this.cropNamecheck = [];
    this.cropDataList.forEach((item) => {
      this.cropNamecheck.push(item.cropName);
    });
    if (this.isNumber(row) == true || !this.cropNamecheck.includes(row)) {
      return 'textRed';
    } else {
      return '';
    }
  }
  //*********************************************** */

  isValidRate(row) {
    let regex = /^(?!0+$)[0-9.]{1,10}$/gm;

    if (this.isNumber(row) == true && row.match(regex)) {
      return '';
    } else {
      return 'textRed';
    }
  }

  isProductType(type) {
    let productdatalistName = [];
    this.productdatalist.forEach((ele) => {
      productdatalistName.push(ele.productType);
    });
    if (productdatalistName.includes(type) === true) {
      return '';
    } else {
      return 'textRed';
    }
  }

  isDate(dateType) {
    if (dateType == undefined) {
      return 'textRed';
    } else {
      return '';
    }
    // if (Object.prototype.toString.call(d) === "[object Date]") {
    // it is a date
    // if (isNaN(d.getTime())) {  // d.valueOf() could also work
    //   return ''
    // } else {
    //   return 'textRed'
    // }
    // }
    //  else {
    //   return 'textRed'
    // }
  }

  isValidVariety(row) {
    let x = [];
    this.productdatalist.forEach((ele) => {
      ele.subProduct.forEach((itm) => {
        x.push(itm.subProductTypeName);
      });
    });
    if (this.isProductType(row['Product'])) {
      return 'textRed';
    } else {
      if (x.includes(row['Sub Product type'])) {
        return '';
      } else {
        return 'textRed';
      }
    }
  }

  dateCompareFun(dateArr) {
    let flag = true;
    let today =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    //let tom = new Date(today.setDate(today.getDate() + 1))
    const tomorrow = new Date(today).getTime();
    dateArr.forEach((ele) => {
      let pastDate = new Date(ele).getTime();

      if (pastDate > tomorrow) {
        flag = false;
      }
    });
    return flag;
  }

  response1;
  uploadData() {
    let checkVal = true;
    let marketNameList = [];

    this.dataSource1.filteredData.forEach((element) => {
      marketNameList.push(element.Market);
    });

    let dateCompare: any = [];

    let currentDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.dataSource1.filteredData.forEach((element) => {
      dateCompare.push(element.Date);
      if (!this.isValid(element)) {
        checkVal = false;
      }
    });
    if (this.dateCompareFun(dateCompare)) {
      if (checkVal) {
        let text = confirm('Are you sure you want to upload this data ?');
        if (text == true) {
          this.spinner.hide();
          const listData = [];
          this.dataSource1.filteredData.forEach((element) => {
            let date =
              element.Date.split('/')[1] +
              '/' +
              element.Date.split('/')[0] +
              '/' +
              element.Date.split('/')[2];

            listData.push({
              market: element.Market,
              producttype: element.Product,
              crop: element.Crop,
              subProducttype: element.subProduct,
              rate: element.Rate,
              unit: element.Unit,
              publishDate: this.datePipe.transform(
                new Date(element.Date),
                'MM/dd/yyyy'
              ),
            });
          });
          this.spinner.show();
          var postdata = {
            bulkMarketRateList: listData,
          };
          this._userService.bulkMarketRate(postdata).subscribe((data) => {
            this.response1 = data;
            this.spinner.hide();
            this.toastr.success(this.response1.result.message, 'Success', {
              timeOut: 3000,
            });
          });
          this.cancelPage();
        } else {
          this.spinner.hide();
        }
      } else {
        alert('Please correct the highlighted row and then upload.');
      }
    } else {
      alert('Future date not allowed.');
    }
  }

  titleCase(str) {
    if (!this.isEmptyOrSpaces(str)) {
      return '';
    }
    // var splitStr = str.toLowerCase().split(' ');
    // for (var i = 0; i < splitStr.length; i++) {
    //   splitStr[i] =
    //     splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    // }
    // return splitStr.join(' ');
    return str;
  }

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(MarketExportData, {
      width: '60%',
      height: '53%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);

              var postdata = {
                fromDate: this.startdata,
                todate: this.enddata,
                search: this.filterbyText,
                market: this.filterbymarketName,
                product: this.filterbyProduct,
                subProduct: this.filterbysubProductName,
                reportList: Result,
              };

              this._userService.getMarketReports(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_MarketRate';
                anchor.href = url;
                anchor.click();
              });
            } else {
              postdata = {
                fromDate: '',
                todate: '',
                search: '',
                market: '',
                product: '',
                subProduct: '',
                reportList: Result,
              };
              this._userService.getMarketReports(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_MarketRate.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one columns to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
}
@Component({
  selector: 'market-export-data',
  templateUrl: 'market-export-data.html',
})
export class MarketExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<MarketExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, value: 'Market', isSelected: false },
      { id: 2, value: 'Product', isSelected: false },
      { id: 3, value: 'Variety', isSelected: false },
      { id: 4, value: 'Rate', isSelected: false },
      { id: 5, value: 'Date', isSelected: false },
      { id: 6, value: 'Updated by', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
